import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles/global.css';
import './index.css';
import App from './App';
import { ThemeProvider } from './context/ThemeContext';
import { ToastProvider } from './context/ToastContext';
import { ConfirmProvider } from './context/ConfirmContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
        <ThemeProvider>
            {/* Toasts and confirmations are mounted once, above the router, so
                every page and hook can reach them. */}
            <ToastProvider>
                <ConfirmProvider>
                    <App />
                </ConfirmProvider>
            </ToastProvider>
        </ThemeProvider>
    </BrowserRouter>
);
